import { elementOpen, elementVoid, elementClose, } from 'incremental-dom';
var mailIcon = function () {
    var paths = [
        "M256,0C114.6,0,0,114.6,0,256S114.6,512,256,512,512,397.4,512,256,397.3,0,256,0Zm0,496C123.5,496,16,388.5,16,256S123.5,16,256,16,496,123.5,496,256,388.5,496,256,496Z",
        "M92.61,387.62V178.46l163.24,109,163.25-109V387.62ZM363.1,202.45l-107,71.41-107-71.41v-29H363.4v29Zm51.55-34.36-40.59,27V162.46H137.34v32.59l-40.59-27L255.55,62.32l159.1,105.77ZM255.85,48.69,81.35,165.12V399.18h349.3V165.12L255.85,48.69Z"
    ];
    elementOpen('svg', null, null, 'class', 'mail-icon contact-icon', 'viewBox', '0 0 512 512');
    paths.map(function (p, i) {
        elementVoid('path', "mailiconpath-" + i, ['d', p]);
    });
    elementClose('svg');
};
export { mailIcon };
//# sourceMappingURL=mail.js.map